import React from "react";

const Head = ({ title }) => {
  return (
    <header class="flex w-full gap-12 items-center bg-[--white-05] py-8 px-4 rounded-xl mb-8">
      <div className="msb-logo max-w-[14rem] aspect-[4]"></div>
      <hgroup className="flex flex-col gap-2">
        <h1>MSB Styling Guide</h1>
        <h3>{title}</h3>
      </hgroup>
    </header>
  );
};

export default Head;
